import { fetchVirtualMarketerPlan } from 'api/clients/PaymentPlanClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { VirtualMarketerPlan } from '../types'
import { useQuery } from 'react-query'

export const useVirtualMarketerPlan = () => {
  return useQuery<VirtualMarketerPlan | null>(
    'virtualMarketerPlan',
    async () => {
      const res = await fetchVirtualMarketerPlan()

      if (res.type === SUCCESS_RESPONSE_TYPE) {
        return res.data.plan
      }

      return null
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
    },
  )
}
